import {Routes, RouterModule} from '@angular/router';
import {SupportedFormatsComponent} from './supported-formats.component';

const routes:Routes = [
  {
    path: 'support-formats',
    component : SupportedFormatsComponent
  }];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/supported-formats/support-formats.routing.ts